import QuestionItem, { QuestionItemProps } from './QuestionItem';
import withInteractor from './QuestionItem.interactor';
import withPresenter from './QuestionItem.presenter';

export type { QuestionItemProps };

export default withInteractor(withPresenter(QuestionItem));
